import React, { useEffect, useState } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';
import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import { DataGrid } from '@mui/x-data-grid';
import { Grid, Modal, Box, TextField, Button } from '@mui/material';

import ConsumablesTypeAutoComplete from '../CommonComponents/ConsumablesTypeAutoComplete';

import ConsumablesEdit from './ConsumablesEdit';

import { gridStyle } from '../shared/commonStyle';
import { changeFirstToUpper } from '../../Helpers/helpers';

const ConsumablesAdmin = () => {
  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  // const [userActive, setUsersActive] = useState('%');
  // const [usersType, setUsersType] = useState('%');
  // const [usersDropdown, setUsersDropdown] = useState('%');
  const [rowData, setRowData] = useState({});
  const [useType, setUseType] = useState(localStorage.getItem('type'));
  //FILTERS

  const [fullFilterBlob, setFullFilterBlob] = useState([]);

  const [byType, setByType] = useState('');
  const [byCode, setByCode] = useState('');
  const [byDescription, setByDescription] = useState('');

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    setForceUpdate(forceUpdate + 1);
  };
  const handleClose = () => {
    setOpen(false);
    setForceUpdate(forceUpdate + 1);
  };

  const changeHandler = (event) => {
    const targetValue = event.target.value;

    let oldData = [...fullFilterBlob];
    let tempData = oldData
      .slice()
      .filter((item) => item.field !== event.target.id);
    targetValue === ''
      ? setFullFilterBlob([...tempData])
      : setFullFilterBlob([
          ...tempData,
          {
            field: event.target.id,
            search: targetValue,
            strict: false,
          },
        ]);
  };

  const changeListHandler = (data) => {
    let oldData = [...fullFilterBlob];
    let tempData = oldData.slice().filter((item) => item.field !== 'type');
    setFullFilterBlob([
      ...tempData,
      {
        field: 'type',
        search: data,
        strict: true,
      },
    ]);
  };

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_consumables`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilters: fullFilterBlob,
      },
      'r2_consumables'
    );
  }, [
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    fullFilterBlob,
    forceUpdate,
  ]);

  const columns = [
    { field: 'type', headerName: 'Type', width: 150, flex: 1,
  
      renderCell:(data) =>(
        
        <>
        {changeFirstToUpper(data.row.type)}
        </>
      )
  },
    { field: 'code', headerName: 'Item Code', width: 150, flex: 1 },
    {
      field: 'description',
      headerName: 'Item Description',
      width: 150,
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              setRowData(data.row);
              handleOpen();
            }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '72vh', width: '100%' }}>
      <Box sx={{ margin: '0 0 10px 0' }}>
        <Grid container>
          <Grid xs={12} md={3}>
            <ConsumablesTypeAutoComplete
              nameLabel='Filter By Stock Type'
              setByType={(data) => changeListHandler(data)}
              // selectedType={rowData.type}
            />
          </Grid>

          <Grid xs={12} md={3}>
            <TextField
              sx={{ width: '80%' }}
              id='code'
              label='Filter By Stock Code'
              variant='outlined'
              // value={name}
              onChange={(event) => changeHandler(event)}
              // onChange={(event) => handleChange(event)}
            />
          </Grid>
          <Grid xs={12} md={3}>
            <TextField
              sx={{ width: '80%' }}
              id='description'
              label='Filter By Stock Description'
              variant='outlined'
              // value={name}
              onChange={(event) => changeHandler(event)}
              // onChange={(event) => handleChange(event)}
            />
          </Grid>
          <Grid xs={12} md={3}></Grid>
        </Grid>
      </Box>
      <DataGrid
        sx={gridStyle}
        rows={data}
        rowCount={totalRows}
        loading={loading}
        pagination
        sortingMode='server'
        filterMode='server'
        onSortModelChange={(model) => {
          setPage(0);
          setSort(model);
        }}
        onFilterModelChange={(model) => {
          setPage(0);
          setFilter(model.quickFilterValues);
        }}
        page={page}
        pageSize={pageSize}
        paginationMode='server'
        onPageChange={(newPage) => {
          setPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        columns={columns}
        onRowClick={(params) => {}}
        onRowDoubleClick={(params) => {
          setRowData(params.row);
          handleOpen();
          // getMyRowData(params.row);
          // setEditOrSave('editMode');
        }}
        rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        componentsProps={{
          toolbar: {
            updateOnclick: () => {
              setUpdateData((i) => i + 1);
            },
            filterOnClick: () => {
              // handleFilterOpen();
            },
            // modalState: modalState,
          },
        }}
      />

      <Button
        sx={{ float: 'right', margin: '15px 0 0 0 ' }}
        variant='contained'
        size='small'
        onClick={() => {
          setRowData(newRowData);
          handleOpen();
        }}
      >
        add
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='parent-modal-Time_Attendance'
        aria-describedby='parent-modal-Time_Attendance_Row_Edit'
      >
        <ConsumablesEdit thisRowData={rowData} cancelEdit={handleClose} />
      </Modal>
    </Box>
  );
};

export default ConsumablesAdmin;

const newRowData = { code: '', description: '', type: '' };
